// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"c42ce658","453":"97562c86"}[chunkId] + ".chunk.js";
};